// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1qiW-","imageUploader":"EGiftCard_imageUploader__2ffvJ"};